import React, { useMemo } from 'react';
import { AppButton, Box, RenewalRequestedBannerIcon } from '@common-fe/common-fe';

import { OrganizationTypes } from '@/common/constants';
import Permissions from '@/common/permissions';
import { BannerBase } from '@/modules/core/components/Banners';
import { useCurrentOrganization, useHasAccess } from '@/modules/core/hooks';

interface RenewalRequestedBannerProps {
  onSetCofirmRenewModalVisible: () => void;
  onSetRenewDetailModalVisible: (value: boolean) => void;
}

const RenewalRequestedBanner: React.FC<RenewalRequestedBannerProps> = ({
  onSetCofirmRenewModalVisible,
  onSetRenewDetailModalVisible,
}) => {
  const hasAccess = useHasAccess([{ permission: Permissions.PLAN_SETUP }]);
  const { defaultOrganizationData } = useCurrentOrganization();

  const isCompleteButtonVisible = useMemo(
    () => hasAccess && (defaultOrganizationData?.type === OrganizationTypes.system
    || defaultOrganizationData?.type === OrganizationTypes.partner
    || defaultOrganizationData?.type === OrganizationTypes.distributor), [defaultOrganizationData?.type, hasAccess]);

  return (
    <Box>
      <BannerBase
        title="Renewal Request Sent!"
        description="Your request to renew your plan has been sent to your account manager. They will be in touch to confirm the details and complete your plan's renewal."
        icon={<RenewalRequestedBannerIcon />}
        testId="renewal-requested"
      >
        <Box direction="row" margin={{top: 'l'}} gap="s">
          <AppButton width="160px" onClick={() => onSetRenewDetailModalVisible(true)}>
            View Details
          </AppButton>
          {isCompleteButtonVisible && (
            <AppButton width="160px" onClick={onSetCofirmRenewModalVisible} buttonType="secondary">
              Mark as Complete
            </AppButton>
          )}
        </Box>
      </BannerBase>
    </Box>
  );
};

export default RenewalRequestedBanner;
